let events;
try {
  events = await import('@shopify/events');
} catch (error) {
  events = null;
}

// `Theme` is a global const (not a window property), so it is read by bare name.
const routes = typeof Theme === 'undefined' ? null : Theme.routes;

if (events && routes && routes.cart_add_url) {
  const { CartLinesUpdateEvent, StandardEvents } = events;
  const fab = document.getElementById('wf-cart-fab');
  const fabCount = document.getElementById('wf-cart-fab-count');
  const getDrawer = () => document.getElementById('cart-drawer');

  const setCount = (count) => {
    if (!fab || !fabCount) return;
    const previous = Number(fabCount.textContent) || 0;
    fabCount.textContent = String(count);
    fab.hidden = count < 1;
    if (count > previous) {
      fab.classList.remove('wf-cart-fab--pop');
      void fab.offsetWidth;
      fab.classList.add('wf-cart-fab--pop');
    }
  };

  const syncCount = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => setCount(cart.item_count))
      .catch(() => {});

  fab?.addEventListener('click', () => getDrawer()?.open());

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(syncCount).catch(() => {});
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) syncCount();
  });

  const showError = (form, message) => {
    let el = form.querySelector('.wf-buy__err');
    if (!el) {
      el = document.createElement('p');
      el.className = 'wf-buy__err';
      el.setAttribute('role', 'alert');
      form.querySelector('.wf-buy__cta')?.insertAdjacentElement('beforebegin', el);
    }
    el.textContent = message;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('wf-buy__form')) return;
    if (!getDrawer()) return;

    event.preventDefault();
    if (form.dataset.wfBusy) return;
    form.dataset.wfBusy = '1';

    const button = form.querySelector('.wf-buy__cta');
    button?.setAttribute('aria-busy', 'true');
    form.querySelector('.wf-buy__err')?.remove();

    const formData = new FormData(form);
    const lines = [];
    for (let i = 0; formData.has(`items[${i}][id]`); i++) {
      lines.push({
        merchandiseId: String(formData.get(`items[${i}][id]`)),
        quantity: Number(formData.get(`items[${i}][quantity]`)) || 1,
      });
    }

    const sectionIds = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean)
      ),
    ];
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    form.dispatchEvent(
      new CartLinesUpdateEvent({ action: 'add', context: 'product', lines, promise: deferred.promise })
    );

    let nativeFallback = false;
    let added = false;
    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const data = await response.json();
      added = response.ok && !data.status;

      if (!response.ok || data.status) {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: true, items: cart.items, source: 'wf-buybox', sourceId: form.id },
        });
        showError(form, data.description || data.message || 'Sorry, that could not be added to your cart.');
      } else {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'wf-buybox',
            sourceId: form.id,
            itemCount: lines.reduce((sum, line) => sum + line.quantity, 0),
            sections: data.sections,
            didError: false,
          },
        });
        setCount(cart.item_count);
        requestAnimationFrame(() => {
          const drawer = getDrawer();
          if (drawer && !drawer.isOpen) drawer.open();
        });
      }
    } catch (error) {
      deferred.reject(error);
      // Never repeat an add that already went through.
      nativeFallback = !added;
    } finally {
      button?.removeAttribute('aria-busy');
      delete form.dataset.wfBusy;
    }

    // Network or parsing failure: fall back to the original full-page add so the customer is never stuck.
    if (nativeFallback) form.submit();
  });
}